import { render, staticRenderFns } from "./EvaluationsTable.vue?vue&type=template&id=c6a2711e&"
import script from "./EvaluationsTable.vue?vue&type=script&lang=js&"
export * from "./EvaluationsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports